<template>
    <div v-if="show" class="modal" @click.self="close">
      <div class="modal-content">
        <h2>Help & Tutorial</h2>
        <div class="help-content" v-html="helpContent"></div>
        <button class="cancel-button" @click="close">Close</button>
      </div>
    </div>
  </template>
  
  <script>
  import { computed } from "vue";
  import { useRoute } from "vue-router";
  
  export default {
    name: "HelpModal",
    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:show"],
    setup(props, { emit }) {
      const route = useRoute();
  
      // Define site-specific help content based on the current route
      const helpContent = computed(() => {
        if (route.path === "/menu") {
          return `<p>On the Menu page, you can generate a weekly menu by clicking "Generate New Menu". Lock your favorite dishes (you can also lock empty days if you have other plans), then click "Save/Export" to store your menu and download a calendar file.</p>`;
        } else if (route.path === "/editor") {
          return `<p>The Dish Editor allows you to add, edit, or delete dishes. Click on a dish to view details and use the editing options to update its information.</p>`;
        } else if (route.path === "/settings") {
          return `<p>In User Settings, you can adjust how often dishes repeat and set your preferences. These settings affect how your weekly menu is generated.</p>`;
        } else if (route.path === "/contact") {
          return `<p>On the Contact page, you can get in touch with us via email and view our project updates on our public Trello board.</p>`;
        } else {
          return `<p>Welcome to FoodPlannerIO! Use the navigation to explore the menu, dish editor, settings, and contact pages for more information.</p>`;
        }
      });
  
      const close = () => {
        emit("update:show", false);
      };
  
      return {
        helpContent,
        close,
      };
    },
  };
  </script>
  
  <style scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3000;
  }
  .modal-content {
    background: #1e1e1e;
    color: #fff;
    padding: 25px 35px;
    border-radius: 10px;
    max-width: 500px;
    width: 90%;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.8);
  }
  .cancel-button {
    margin-top: 20px;
    background-color: #dc3545;
    color: #fff;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .cancel-button:hover {
    background-color: #b52e3a;
  }
  .help-content {
    text-align: left;
    margin-bottom: 15px;
  }
  </style>
  